__turbopack_context__.v({
  "user-name": "CardName-module-scss-module__8fGJ-W__user-name",
});
